import container from '../../libs/container/container';
import formValidatorFactory, {
	EmailFieldObject
} from '../../libs/form/form-validator';
import jumpFactory from '../../libs/jump/jump';

export interface PublicVarsInterface {
	cssId: {
		newsletterCls: string;
		newsletterInputCls: string;
		newsletterInputErrorCls: string;
		newsletterWrapperCls: string;
		newsletterLoadingCls: string;
		newsletterLoaderWrapperCls: string;
		newsletterWrapperThxCls: string;
		newsletterThxBtnCls: string;
		newsletterThxSuccessCls: string;
		newsletterThxFailedCls: string;
		newsletterThxDisabledCls: string;
		headerCls: string;
	},

	rand?: string,
	apiNewsletterEndpoint?: string;
	apiNewsletterEndpointAction?: string;
}

interface PrivateVarsInterface {
	name: string;
	formInitialSend: boolean,
	emailFields: Record<string, Omit<EmailFieldObject, 'status'>>,
}

interface ServiceInterface {
	formValidator?: ReturnType<typeof formValidatorFactory.create>;
	jump?: ReturnType<typeof jumpFactory.create>;
}

const newsletterService = function (id: number) {

	let publicVars: PublicVarsInterface;

	let privateVars: PrivateVarsInterface;

	let service: ServiceInterface = {};

	const methods = {
		init: (options: PublicVarsInterface) => {
			publicVars = options;

			privateVars = {
				name: 'newsletterService(' + id + ')',
				formInitialSend: false,
				emailFields: {},
			}

			methods.bind();
			methods.startup();
		},

		startup: function () {
			service.jump = jumpFactory.create();
			service.jump.init();

			service.formValidator = formValidatorFactory.create();
			service.formValidator.init();

			if (publicVars.cssId.newsletterInputCls) {
				privateVars.emailFields = {
					'email': {
						field: publicVars.cssId.newsletterInputCls,
						errorField: publicVars.cssId.newsletterInputCls,
						errorClass: publicVars.cssId.newsletterInputErrorCls.substring(1),
						isRequired: true,
						defaultValue: ''
					}
				};
			}

			service.formValidator.setEmailFields(privateVars.emailFields);
		},
		bind: function () {
			container.msg(privateVars.name, 'module started');

			methods.bindNewsletterFormElements();
		},

		bindNewsletterFormElements() {
			if(publicVars.cssId.newsletterCls) {
				const newsletterFormHtml = document.querySelector(publicVars.cssId.newsletterCls) as HTMLFormElement;

				newsletterFormHtml.addEventListener('submit', (e) => {
					e.preventDefault();

					methods.handleNewsletterFormSubmit();
				});
			}

			if (publicVars.cssId.newsletterInputCls) {
				const newsletterInputHtml = document.querySelector(publicVars.cssId.newsletterInputCls);

				newsletterInputHtml?.addEventListener('blur', () => {
					if (privateVars.formInitialSend) {
						service.formValidator?.validateEmailField('email', true);
					}
				});

				newsletterInputHtml?.addEventListener('focus', () => {
					newsletterInputHtml.classList.remove(
						publicVars.cssId.newsletterInputErrorCls.substring(1) || '');
				});
			}

			if(publicVars.cssId.newsletterThxBtnCls) {
				const thxBtnCloseHtml = document.querySelector(publicVars.cssId.newsletterThxBtnCls);

				thxBtnCloseHtml?.addEventListener('click', () => {
					methods.closeThxFormMsg();
				})
			}
		},

		async handleNewsletterFormSubmit() {
			privateVars.formInitialSend = true;

			if (!service.formValidator) {
				container.errorMsg(privateVars.name, 'formValidator service not found');
				return;
			}

			if (!publicVars.cssId.newsletterCls) {
				container.errorMsg(privateVars.name, 'form id not found');
				return;
			}

			const formHtml = document.querySelector(publicVars.cssId.newsletterCls) as HTMLFormElement;

			if (!formHtml || !publicVars?.apiNewsletterEndpoint || !publicVars?.apiNewsletterEndpointAction || !publicVars.rand) {
				container.errorMsg(privateVars.name, 'form config error');
				return;
			}

			const validationResults = service.formValidator.validate();

			if (!validationResults.validFlag) {

				let modifier = this.getHeaderHeight() + 20;

				if (service.jump) {
					service.jump.centerTo(publicVars.cssId.newsletterInputErrorCls, {
						speed: 200,
						modifier: modifier
					}, () => {
					});
				}
			} else {
				container.msg(privateVars.name, 'form validation passed');

				const formWrapperHtml = document.querySelector(
					publicVars.cssId.newsletterWrapperCls);

				formWrapperHtml?.classList.add(publicVars.cssId.newsletterLoadingCls.substring(1));

				let modifier = this.getHeaderHeight() + 20;

				if (service.jump) {
					service.jump.centerTo(publicVars.cssId.newsletterLoaderWrapperCls, {
						speed: 200,
						modifier: modifier
					}, () => {
					});
				}

				const emailHtml = document.querySelector(publicVars.cssId.newsletterInputCls) as HTMLInputElement;

				let formData = new FormData();

				formData.append('rand', publicVars.rand);
				formData.append('act', publicVars.apiNewsletterEndpointAction);
				formData.append('email', emailHtml?.value);

				const response = await fetch(publicVars.apiNewsletterEndpoint, {
					method: 'POST',
					body: formData
				});

				const newsletterFormHeaderThxSuccessHtml = document.querySelector(publicVars.cssId.newsletterThxSuccessCls) as HTMLElement;
				const newsletterFormHeaderThxFailedHtml = document.querySelector(publicVars.cssId.newsletterThxFailedCls) as HTMLElement;

				if(!response.ok) {
					formWrapperHtml?.classList.remove(publicVars.cssId.newsletterLoadingCls.substring(1) || '');
					newsletterFormHeaderThxSuccessHtml.classList.add(publicVars.cssId.newsletterThxDisabledCls.substring(1) || '');
					newsletterFormHeaderThxFailedHtml.classList.remove(publicVars.cssId.newsletterThxDisabledCls.substring(1) || '');
					formWrapperHtml?.classList.add(publicVars.cssId.newsletterWrapperThxCls.substring(1) || '');
					return;
				}

				const data = await response.json();

				setTimeout(() => {
					newsletterFormHeaderThxSuccessHtml.classList.remove(publicVars.cssId.newsletterThxDisabledCls.substring(1) || '');
					newsletterFormHeaderThxFailedHtml.classList.add(publicVars.cssId.newsletterThxDisabledCls.substring(1) || '');
					formWrapperHtml?.classList.remove(publicVars.cssId.newsletterLoadingCls.substring(1) || '');
					formWrapperHtml?.classList.add(publicVars.cssId.newsletterWrapperThxCls.substring(1) || '');
				}, 1000);
			}
		},

		getHeaderHeight() {
			let headerHeight = 0;

			if (publicVars.cssId.headerCls) {
				const header = document.querySelector(publicVars.cssId.headerCls) as HTMLElement;

				headerHeight = header?.offsetHeight || 0;
			}

			return headerHeight;
		},

		closeThxFormMsg() {
			if(!publicVars.cssId.newsletterWrapperCls) {
				container.errorMsg(privateVars.name, 'form config error');
				return
			}

			const formWrapperHtml = document.querySelector(
				publicVars.cssId.newsletterWrapperCls);

			formWrapperHtml?.classList.remove(publicVars.cssId.newsletterWrapperThxCls.substring(1) || '');

			const formHtml = document.querySelector(publicVars.cssId.newsletterCls) as HTMLFormElement;

			if (!formHtml) {
				container.errorMsg(privateVars.name, 'form not found');
				return;
			}

			formHtml.reset();
		}
	}

	return {
		init: function (options: PublicVarsInterface) {
			methods.init(options);
		}
	}
}

const factory = {
	objId: 0,

	create: function () {
		factory.objId++;

		return newsletterService(factory.objId);
	}
};

export default {
	create: factory.create
};